<template>
  <div class="">
    <ol class="legend border bg-light">
      <li>
        <span class="SPOEBD">EBD</span>
        <span> - <translate>Early Booking</translate></span>
      </li>
      <li>
        <span class="SPOEBD">SPO</span>
        <span> - <translate>Special Offer</translate></span>
      </li>
      <li>
        <span class="SPOEBD">LM</span>
        <span> - <translate>Last Minute</translate></span>
      </li>
      <li>
        <span class="FCAVL">FC</span>
        <span> - <translate>Free Child</translate></span>
      </li>
      <li>
        <span class="FCAVL">AVL</span>
        <span> - <translate>Available</translate></span>
      </li>
      <li>
        <span class="RQNA">RQ</span>
        <span> - <translate>On Request</translate></span>
      </li>
      <li>
        <span class="RQNA">N/A</span>
        <span> - <translate>Stop Sale</translate></span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Legend'
}
</script>
